import pace, { routeWantsPace } from 'utils/pace'

export default (to, from, next) => {
  if (
    to.matched.some(route => routeWantsPace(route, to, from) === false) &&
    from.matched.some(route => routeWantsPace(route, to, from) === false)
  ) {
    next()

    return
  }

  // Calling "pace.stop" clears out any existing Pace loaders and then we'll forcibly render
  // the loading bar. This prevents Pace from hiding the bar for us. We'll do this ourselves
  // in the last hook where we reset some Pace defaults and start it properly.
  pace.stop()
  pace.bar.render()

  next()
}
